import { render, staticRenderFns } from "./OptionGroupsAssignmentSidebar.vue?vue&type=template&id=f89ef2d4&scoped=true"
import script from "./OptionGroupsAssignmentSidebar.vue?vue&type=script&lang=js"
export * from "./OptionGroupsAssignmentSidebar.vue?vue&type=script&lang=js"
import style0 from "./OptionGroupsAssignmentSidebar.vue?vue&type=style&index=0&id=f89ef2d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89ef2d4",
  null
  
)

export default component.exports